import {SmartTriggerProcessorInput} from "../../../types";
import './createProcessorInputModal.css'

import {Button, Modal, Select, Textarea, TextInput} from '@mantine/core'
import {useRef, useState} from "react";
import {ObjectUtils} from "../../../../../utils/objectUtils";

export type CreateProcessorInputModalProps = {
    opened: boolean,
    onClose: () => void,
    onNewInput: (condition: SmartTriggerProcessorInput) => void
}

export function CreateProcessorInputModal({opened, onClose, onNewInput}: CreateProcessorInputModalProps) {

    const [errors, setErrors] = useState<Record<string, string>>({});

    const typeRef = useRef<HTMLInputElement>(null);

    const nameRef = useRef<HTMLInputElement>(null);

    const defaultValueRef = useRef<HTMLInputElement>(null);

    const descriptionRef = useRef<HTMLTextAreaElement>(null);

    function saveInput() {
        const type = typeRef?.current?.value;
        const name = nameRef?.current?.value
        const defaultValue = defaultValueRef.current?.value
        const description = descriptionRef.current?.value;
        const validationErrors = validate(type, name, defaultValue, description);
        if (ObjectUtils.isEmpty(validationErrors)) {
            setErrors({})
            onNewInput({
                type, name, defaultValue, description
            } as any)
        } else {
            setErrors(validationErrors)
        }
    }

    function validate(type: string | undefined, name: string | undefined, defaultValue: string | undefined, description: string | undefined) {
        const validationErrors: Record<string, string> = {}
        if (!type) {
            validationErrors['type'] = 'Please choose a data type'
        }
        if (!name) {
            validationErrors['name'] = "Please provide the name"
        }
        if (!description) {
            validationErrors['description'] = 'Please provide the description'
        }
        return validationErrors;
    }

    function onModalClose() {
        setErrors({})
        onClose()
    }


    return (
        <Modal
            className={"processor-input-modal"}
            opened={opened}
            onClose={onModalClose}
        >
            <div>
                <div className={"processor-input-modal-parent"}>
                    <div>
                        <h3>Create new Input</h3>
                    </div>

                    <div className={"processor-input-modal-parent-input-group"}>
                        <Select error={errors['type']} ref={typeRef} label={"Type"}
                                data={['STRING', 'JSON', 'NUMBER', 'ARRAY', 'CHOICE', 'DATE']}/>
                        <TextInput
                            error={errors['name']}
                            ref={nameRef}
                            placeholder="Name"
                            label={"Name"}
                        />
                        <TextInput
                            ref={defaultValueRef}
                            label={"Default Value"}
                            placeholder=""
                        />

                    </div>

                    <Textarea
                        error={errors['description']}
                        ref={descriptionRef}
                        label={"Description"}
                        placeholder="Provide some information about this input"
                        required
                    />
                    <div style={{display: "flex", justifyContent: "center"}}>
                        <Button variant={'outline'} color={"teal"} onClick={() => saveInput()}>
                            Save
                        </Button>
                    </div>


                </div>

            </div>


        </Modal>
    )
}
